import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useT } from "@/i18n";

const PowerInAction = () => {
  const { t } = useT();
  return (
    <section data-testid="power-section" className="relative py-24 sm:py-32 bg-[#faf7f2] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-8">
            <div className="overline mb-6">{t.power.overline}</div>
            <h2 className="font-display text-4xl sm:text-6xl tracking-tight leading-[1.02]">
              {t.power.h}<br />{t.power.h2}<br /><span className="text-[#ea7a1f]">{t.power.h3}</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <figure className="md:col-span-7 relative aspect-[4/3] overflow-hidden group">
            <img
              src="/generated/pool_deck.png"
              alt="Exposed-aggregate decorative concrete pool deck"
              className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
            />
            <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/60 to-transparent p-8">
              <div className="overline !text-white">CASE / 01</div>
              <div className="font-display text-2xl mt-2 text-white">{t.power.cases[0]}</div>
            </figcaption>
          </figure>

          <div className="md:col-span-5 grid grid-rows-2 gap-6">
            <figure className="relative overflow-hidden group">
              <img
                src="/generated/patio_finish.png"
                alt="Decorative concrete patio with exposed aggregate finish"
                className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
                <div className="overline !text-white">CASE / 02</div>
                <div className="font-display text-xl mt-1 text-white">{t.power.cases[1]}</div>
              </figcaption>
            </figure>
            <figure className="relative overflow-hidden group">
              <img
                src="/generated/driveway.png"
                alt="Exposed-aggregate concrete driveway"
                className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6">
                <div className="overline !text-white">CASE / 03</div>
                <div className="font-display text-xl mt-1 text-white">{t.power.cases[2]}</div>
              </figcaption>
            </figure>
          </div>
        </div>

        <a
          href="#quote"
          data-testid="see-spec-link"
          className="mt-12 inline-flex items-center gap-3 text-[#ea7a1f] hover:text-[#f08b34] copper-line"
        >
          {t.power.cta} <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
};

export default PowerInAction;
